export default function getCallResult(result) {
    return Object.assign({}, {
        succeeded: true,
        status: 200,
        errorMessage: null,
        data: null
    }, result);
}
